import React, { useEffect, useState } from 'react';
import { useBlocker, useNavigate } from 'react-router-dom';
import Button from '../../../../../component/ui/Button';
import CustomerForm from './customerForm';
import { toast } from 'react-toastify';
import { createCustomer } from '../../../../../services/customers';
import Modal from '../../../../../component/modal/Modal';
import { master_data } from '../../../../../store/action/master';
import { useDispatch, useSelector } from 'react-redux';
import { getCities } from '../../../../../services/vendor';
import { hasPermission, newObjectCreater } from '../../../../../utils/controller';

const CreateCustomer = () => {
	const suburl = localStorage.getItem('suburl');
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [errors, setError] = useState({});
	const [isLoading, setLoading] = useState(false);
	const [isNextLocation, setIsNextLocation] = useState(null);
	const [isLocationBlocker, setIsLocationBlocker] = useState(true);
	const [isCustomerAutoSave, setIsCustomerAutoSave] = useState(false);
	const [prescriptionsDocsList, setPrescriptionsDocsList] = useState([]);
	const [cityList, setCityList] = useState([]);
	const [customerData, setCustomerData] = useState({
		basicDetails: {
			customer_type: 0,
			customer_name: '',
			company_name: '',
			customer_display_name: '',
			customer_email: '',
			customer_phone_mobile: '',
			customer_phone_work: '',
			customer_credit_days: '',
		},
		othersDetails: {
			pan_number: '',
			gst_number: '',
			currency: 'INR',
			is_enable_portal: false,
		},
		address: {
			attention: '',
			country_id: '',
			street_1: '',
			street_2: '',
			city_id: null,
			state_id: null,
			zip_code: '',
		},
		customerRemark: {
			remark_text: '',
		},
	});
	const [customerDocs, setCustomerDocs] = useState({
		gstDocs: null,
		adhaarDocs: null,
		panDocs: null,
		drugLicanceDocs: null,
		fssaiDocs: null,
	});

	const checkValidation = () => {
		var error = { ...errors };

		if (
			!customerData.basicDetails.customer_name ||
			customerData.basicDetails.customer_name === undefined ||
			customerData.basicDetails.customer_name === ''
		) {
			error.customer_name = 'Please enter customer name in the field';
		} else {
			delete error.customer_name;
		}

		if (customerData.basicDetails.customer_type === 1) {
			if (
				!customerData.basicDetails.company_name ||
				customerData.basicDetails.company_name === undefined ||
				customerData.basicDetails.company_name === ''
			) {
				error.company_name = 'Please enter company name in the field';
			} else {
				delete error.company_name;
			}
		} else {
			delete error.company_name;
		}
		if (
			!customerData.basicDetails.customer_display_name ||
			customerData.basicDetails.customer_display_name === undefined ||
			customerData.basicDetails.customer_display_name === ''
		) {
			error.customer_display_name = 'Please enter customer display name in the field';
		} else {
			delete error.customer_display_name;
		}

		if (Object.keys(error).length > 0) {
			setError(error);
			return true;
		} else {
			return false;
		}
	};

	const handleSaveCustomer = async (status) => {
		const checkError = checkValidation();
		if (checkError) {
			toast.error('Unable to create customer');
		} else {
			setLoading(true);
			const formData = new FormData();
			const customerObj = {
				type: customerData.basicDetails.customer_type,
				status: status,
				name: customerData.basicDetails.customer_name,
				display_name: customerData.basicDetails.customer_display_name,
				email: customerData.basicDetails.customer_email,
				phone: customerData.basicDetails.customer_phone_work,
				mobile: customerData.basicDetails.customer_phone_mobile,
				credit_days: customerData.basicDetails.customer_credit_days,
				is_enable_portal: customerData.othersDetails.is_enable_portal,

				attention:
					customerData.address.attention !== '' && customerData.address.attention !== null
						? customerData.address.attention
						: '',
				country_id:
					customerData.address.country_id !== '' && customerData.address.country_id !== null
						? customerData.address.country_id
						: '',
				city_id:
					customerData.address.city_id !== '' && customerData.address.city_id !== null
						? customerData.address.city_id
						: '',
				street1:
					customerData.address.street_1 !== '' && customerData.address.street_1 !== null
						? customerData.address.street_1
						: '',
				street2:
					customerData.address.street_2 !== '' && customerData.address.street_2 !== null
						? customerData.address.street_2
						: '',
				state_id:
					customerData.address.state_id !== '' && customerData.address.state_id !== null
						? customerData.address.state_id
						: '',
				zipcode:
					customerData.address.zip_code !== '' && customerData.address.zip_code !== null
						? customerData.address.zip_code
						: '',
			};
			for (const key in customerObj) {
				formData.append(key, customerObj[key]);
			}

			if (customerData.basicDetails.company_name && customerData.basicDetails.customer_type === 1) {
				var business_info = {
					company_name: customerData.basicDetails.company_name,
					...(customerData.othersDetails.gst_number
						? { gst_number: customerData.othersDetails.gst_number }
						: {}),
				};
				formData.append('customer_business', JSON.stringify(business_info));
			}
			if (customerData.othersDetails.pan_number) {
				formData.append('pan', customerData.othersDetails.pan_number);
			}
			if (customerData.othersDetails.currency) {
				formData.append('currency', customerData.othersDetails.currency);
			}
			if (customerData.customerRemark.remark_text) {
				formData.append('remarks', customerData.customerRemark.remark_text);
			}

			if (customerDocs.gstDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('gst_doc', customerDocs.gstDocs);
			}
			if (customerDocs.drugLicanceDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('drug_lisence_doc', customerDocs.drugLicanceDocs);
			}
			if (customerDocs.fssaiDocs && customerData.basicDetails.customer_type === 1) {
				formData.append('fssai_doc', customerDocs.fssaiDocs);
			}
			if (customerDocs.adhaarDocs) {
				formData.append('aadhar_card_doc', customerDocs.adhaarDocs);
			}

			prescriptionsDocsList.forEach((pdoc) => {
				formData.append('prescription_doc', pdoc?.imagePath);
			});

			if (customerDocs.panDocs) {
				formData.append('pan_doc', customerDocs.panDocs);
			}
			try {
				const res = await createCustomer(formData);
				if (res?.success) {
					toast.success(res?.message);
					setIsLocationBlocker(false);
					setIsCustomerAutoSave(false);
					setTimeout(() => {
						navigate(`/user/${suburl}/customers`);
					}, 300);
				} else {
					toast.error(res?.message || 'Something went wrong');
				}
			} catch (error) {
				toast.error(error?.message || 'Something went wrong');
			} finally {
				setLoading(false);
			}
		}
	};

	async function getCity(stateId) {
		try {
			var body = {
				state_id: Number(stateId),
			};
			var res = await getCities(body);
			if (res?.success) {
				var cities = newObjectCreater(res?.data);
				setCityList(cities);
			}
		} catch (error) {
			toast.error(error);
		}
	}
	useBlocker((tx) => {
		if (isLocationBlocker) {
			setIsNextLocation(tx);
			setIsCustomerAutoSave(true);
			return true;
		}
		return false;
	});

	useEffect(() => {
		dispatch(master_data());
	}, [dispatch]);

	useEffect(() => {
		getCity(customerData.address.state_id);
	}, [customerData.address.state_id]);

	return (
		<div>
			<div className="product-pg-header add-product">
				<p>Create New Customer</p>
				<div className="add-product-button">
					<Button
						type="button"
						className="btn-primary mt-0 px-4"
						button="Save"
						loader={isLoading}
						disabled={
							isLoading || !hasPermission('sales.customers.create', user?.role?.role_permissions)
						}
						onClick={() => {
							setIsCustomerAutoSave(false);
							handleSaveCustomer(1);
						}}
					/>

					<Button
						type="button"
						className="mt-0 btn-danger add-pro"
						button=""
						close
						onClick={() => navigate(`/user/${suburl}/customers`)}
					/>
				</div>
			</div>
			<CustomerForm
				setCustomerData={setCustomerData}
				setPrescriptionsDocsList={setPrescriptionsDocsList}
				prescriptionsDocsList={prescriptionsDocsList}
				customerData={customerData}
				customerDocs={customerDocs}
				cityList={cityList}
				setCustomerDocs={setCustomerDocs}
				errors={errors}
				setError={setError}
				isEdit={false}
			/>
			{isCustomerAutoSave && (
				<Modal
					className="deleteVendorsModal"
					title="Customer Auto Save"
					isOpen={isCustomerAutoSave}
					onClose={() => {
						setIsCustomerAutoSave(false);
					}}
					cancelButton={() => {
						setIsCustomerAutoSave(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						You have unsaved changes. Do you want to continue without saving?
					</div>

					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Leave Without Saving"
							className="mt-0 px-4 btn-danger relative"
							onClick={() => {
								setIsLocationBlocker(false);
								setIsCustomerAutoSave(false);
								setTimeout(() => {
									navigate(isNextLocation.nextLocation?.pathname);
								}, 300);
							}}
						/>
						<Button
							type="button"
							button="Save and Continue"
							disabled={!hasPermission('sales.customers.create', user?.role?.role_permissions)}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								setIsCustomerAutoSave(false);
								handleSaveCustomer(1);
							}}
						/>
					</div>
				</Modal>
			)}
		</div>
	);
};
export default CreateCustomer;
